var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { OGButton } from '@opengear/buttons';
import Stack from '@mui/material/Stack';
import { useSystemConfigBackup } from '@/api/system/config/system-config';
import { ResetButton, FormContainer, FormActions } from '@/components/layout/forms';
import { PasswordField, ConfirmPasswordField, UserFiles, EncryptBackupToggleButton } from './config-backup-form-controls';
import { transformToRequestObject } from './transformer';
var defaultValues = {
    encrypt: false,
    password: '',
    confirm: '',
    userFiles: '',
};
export function ConfigBackupForm(_a) {
    var _this = this;
    var permissions = _a.permissions;
    var t = useTranslation().t;
    var configBackupRequest = useSystemConfigBackup();
    var methods = useForm({ mode: 'onTouched', defaultValues: defaultValues });
    var formState = methods.formState;
    // The form can be submitted as long as it's valid - Doesn't need to be dirty
    var submitDisabled = !formState.isValid;
    var onSubmit = useCallback(function (formData) { return __awaiter(_this, void 0, void 0, function () {
        var updatedFormData, updatedData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedFormData = transformToRequestObject(formData);
                    return [4 /*yield*/, configBackupRequest(updatedFormData)];
                case 1:
                    updatedData = _a.sent();
                    if (updatedData) {
                        methods.reset(defaultValues);
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [configBackupRequest, methods]);
    var isEncrypted = methods.watch('encrypt');
    return (_jsxs(FormContainer, __assign({ ariaLabel: t('pages.backup_restore_reset.tabs.config_backup.title'), mode: "create", permissions: permissions, methods: methods, onSubmit: onSubmit }, { children: [_jsx(UserFiles, {}), _jsx(EncryptBackupToggleButton, {}), isEncrypted && (_jsxs(Stack, __assign({ marginTop: 2 }, { children: [_jsx(PasswordField, {}), _jsx(ConfirmPasswordField, {})] }))), _jsxs(FormActions, { children: [_jsx(ResetButton, {}), _jsx(OGButton, __assign({ type: "submit", disabled: submitDisabled || !permissions.hasEditPermission, loading: formState.isSubmitting }, { children: t('pages.backup_restore_reset.tabs.config_backup.form.buttons.download') }))] })] })));
}
